"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Image {
    constructor(mini, thumb, medium, isDefaultImage, hasWebpImage, miniWebp, thumbWebp, mediumWebp) {
        this.mini = mini;
        this.thumb = thumb;
        this.medium = medium;
        this.isDefaultImage = isDefaultImage;
        this.hasWebpImage = hasWebpImage;
        this.miniWebp = miniWebp;
        this.thumbWebp = thumbWebp;
        this.mediumWebp = mediumWebp;
    }
}
exports.default = Image;
